import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons

// core components
import GridContainer from "../../../components/Grid/GridContainer.jsx";
import GridItem from "../../../components/Grid/GridItem.jsx";

import completedStyle from "../../../assets/jss/material-kit-react/views/componentsSections/completedStyle.jsx";

const style = {
  textAlign: 'justify',
};

class SectionCompletedExamples extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.section}>
        <div className={classes.container}>
          <GridContainer justify="center">
              {(this.props.title)?<h2>{this.props.title}</h2>:null}
              <h4 style={style}>{this.props.description}</h4> 
          </GridContainer>
        </div>
      </div>
    );
  }
}

export default withStyles(completedStyle)(SectionCompletedExamples);



// WEBPACK FOOTER //
// ./src/views/Components/Sections/SectionCompletedExamples.jsx